module.exports = __webpack_public_path__ + "static/media/logo.fc2c8eda.png";